var map = {
	"./anchor-blue.svg": 1784,
	"./arr-down.svg": 1785,
	"./arr-up.svg": 1786,
	"./arrow-down-blue.svg": 1787,
	"./arrow-down-circle.svg": 1788,
	"./arrow-down.svg": 1789,
	"./arrow-left.svg": 1790,
	"./arrow-right.svg": 1791,
	"./arrow-up-circle.svg": 1792,
	"./arrow-up.svg": 1793,
	"./article.svg": 1794,
	"./basket-light.svg": 1795,
	"./basket.svg": 1796,
	"./btn-arrow-dark.svg": 1797,
	"./btn-arrow-down-blue.svg": 1798,
	"./btn-arrow-down.svg": 1799,
	"./btn-arrow.svg": 1800,
	"./btn-info.svg": 1801,
	"./btn-play.svg": 1802,
	"./calendar.svg": 1803,
	"./chevron-down.svg": 1804,
	"./chevron-left.svg": 1805,
	"./chevron-right.svg": 1806,
	"./chevron-up.svg": 1807,
	"./clock.svg": 1808,
	"./cross.svg": 1809,
	"./curve-shape-narrow-swoosh.svg": 1810,
	"./curve-shape-right.svg": 1811,
	"./curve-shape-short.svg": 1812,
	"./curve-shape.svg": 1813,
	"./download.svg": 1814,
	"./facebook.svg": 1815,
	"./fantasy.svg": 1816,
	"./gallery.svg": 1817,
	"./i.svg": 1818,
	"./instagram.svg": 1819,
	"./linkedin.svg": 1820,
	"./live-header-logo.svg": 1821,
	"./logo-open.svg": 1822,
	"./menu-close.svg": 1823,
	"./menu-light.svg": 1824,
	"./minus.svg": 1825,
	"./mute.svg": 1826,
	"./pause.svg": 1827,
	"./play.svg": 1828,
	"./plus.svg": 1829,
	"./profile-light.svg": 1830,
	"./radioff.svg": 1831,
	"./radion.svg": 1832,
	"./read.svg": 1833,
	"./restart.svg": 1834,
	"./scores.svg": 1835,
	"./search.svg": 1836,
	"./shop.svg": 1837,
	"./sorting.svg": 1838,
	"./star.svg": 1839,
	"./symbol.svg": 1840,
	"./text.svg": 1841,
	"./tick.svg": 1842,
	"./ticket.svg": 1843,
	"./tiktok.svg": 1844,
	"./track.svg": 1845,
	"./triangle.svg": 1846,
	"./twitter.svg": 1847,
	"./unmute.svg": 1848,
	"./video.svg": 1849,
	"./watch.svg": 1850,
	"./youtube.svg": 1851
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 846;